// extracted by mini-css-extract-plugin
export default {"router":"App_router__bog0P","containedInIFrame":"App_containedInIFrame__X5hXs"};